import Lookup from './types/Lookup';

export const questionTypes = { Lookup };
